import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from './auth/ProtectedRoute';
import { SystemLayout } from './layout/SystemLayout';
import { CustomerPortalLayout } from './layout/CustomerPortalLayout';
import { CatchAllRedirect } from './components/CatchAllRedirect';
import { BillingDashboardPage } from './pages/BillingDashboardPage';
import { BillingInvoicesPage } from './pages/BillingInvoicesPage';
import { BillingModulePricesPage } from './pages/BillingModulePricesPage';
import { BillingPricingPreviewPage } from './pages/BillingPricingPreviewPage';
import { BillingSmsUsagePage } from './pages/BillingSmsUsagePage';
import { BillingInvoiceDetailPage } from './pages/BillingInvoiceDetailPage';
import { CustomerDetailPage } from './pages/CustomerDetailPage';
import { CustomersPage } from './pages/CustomersPage';
import { DashboardPage } from './pages/DashboardPage';
import { ForbiddenPage } from './pages/ForbiddenPage';
import { LoginPage } from './pages/LoginPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { PaymentsPage } from './pages/PaymentsPage';
import { PlansPage } from './pages/PlansPage';
import { ProfilePage } from './pages/ProfilePage';
import { SubscriptionsPage } from './pages/SubscriptionsPage';
import { SupportInboxPage } from './pages/SupportInboxPage';
import { SupportNotificationSettingsPage } from './pages/SupportNotificationSettingsPage';
import { SupportTicketDetailPage } from './pages/SupportTicketDetailPage';
import { TenantDetailPage } from './pages/TenantDetailPage';
import { TenantsPage } from './pages/TenantsPage';
import { TrialOnboardingPage } from './pages/TrialOnboardingPage';
import { ProvisioningReadinessPage } from './pages/ProvisioningReadinessPage';
import { AcceptInvitationPage } from './pages/AcceptInvitationPage';
import { PublicRegisterPage } from './pages/PublicRegisterPage';
import { PublicRegisterLaunchStatusPage } from './pages/PublicRegisterLaunchStatusPage';
import { OnboardingIntentsPage } from './pages/OnboardingIntentsPage';
import { OnboardingIntentDetailPage } from './pages/OnboardingIntentDetailPage';
import { CustomerPortalDashboardPage } from './pages/portal/CustomerPortalDashboardPage';
import { CustomerPortalTenantsPage } from './pages/portal/CustomerPortalTenantsPage';
import { CustomerPortalSupportPage } from './pages/portal/CustomerPortalSupportPage';
import { CustomerPortalSupportTicketPage } from './pages/portal/CustomerPortalSupportTicketPage';
import { CustomerPortalBillingPage } from './pages/portal/CustomerPortalBillingPage';
import { CustomerPortalProfilePage } from './pages/portal/CustomerPortalProfilePage';
import { CustomerPortalCustomersPage } from './pages/portal/CustomerPortalCustomersPage';
import { CustomerPortalCustomerDetailPage } from './pages/portal/CustomerPortalCustomerDetailPage';
import { AccountSecurityPage } from './pages/AccountSecurityPage';
import { CustomerPortalAccountSecurityPage } from './pages/portal/CustomerPortalAccountSecurityPage';
import { NotificationsPage } from './pages/NotificationsPage';
import { NotificationPreferencesPage } from './pages/NotificationPreferencesPage';
import { NotificationTemplatesPage } from './pages/NotificationTemplatesPage';
import { ExternalProvidersPage } from './pages/ExternalProvidersPage';
import { ExternalProviderHealthPage } from './pages/ExternalProviderHealthPage';
import { StripeDashboardPage } from './pages/StripeDashboardPage';
import { StripeWebhookEventsPage } from './pages/StripeWebhookEventsPage';
import { StripeSyncLogsPage } from './pages/StripeSyncLogsPage';
import { RecycleBinPage } from './pages/RecycleBinPage';
import { DataLifecycleEventsPage } from './pages/DataLifecycleEventsPage';
import { DataPurgeJobsPage } from './pages/DataPurgeJobsPage';
import { RetentionPoliciesPage } from './pages/RetentionPoliciesPage';
import { FeatureModulesPage } from './pages/FeatureModulesPage';
import { FeaturesPage } from './pages/FeaturesPage';
import { PlanFeaturesPage } from './pages/PlanFeaturesPage';
import { EntitlementEvaluationsPage } from './pages/EntitlementEvaluationsPage';
import { CustomerPortalEntitlementsPage } from './pages/portal/CustomerPortalEntitlementsPage';
import { TenantAccessDashboardPage } from './pages/TenantAccessDashboardPage';
import { TenantAccessChecksPage } from './pages/TenantAccessChecksPage';
import { TenantAccessEventsPage } from './pages/TenantAccessEventsPage';
import { SetupWizardDashboardPage } from './pages/SetupWizardDashboardPage';
import { SetupWizardSessionsPage } from './pages/SetupWizardSessionsPage';
import { SetupWizardEventsPage } from './pages/SetupWizardEventsPage';
import { TenantProvisioningDashboardPage } from './pages/TenantProvisioningDashboardPage';
import { TenantProvisioningRunsPage } from './pages/TenantProvisioningRunsPage';
import { TenantProvisioningEventsPage } from './pages/TenantProvisioningEventsPage';
import { TenantProvisioningHealthChecksPage } from './pages/TenantProvisioningHealthChecksPage';
import { TenantSchemaDashboardPage } from './pages/TenantSchemaDashboardPage';
import { TenantSchemaVersionsPage } from './pages/TenantSchemaVersionsPage';
import { TenantSchemaAuditPage } from './pages/TenantSchemaAuditPage';
import { TenantSchemaPlansPage } from './pages/TenantSchemaPlansPage';
import { TenantSchemaEventsPage } from './pages/TenantSchemaEventsPage';
import { MafertAppModulesPage } from './pages/MafertAppModulesPage';
import { ModuleSetupProfilesPage } from './pages/ModuleSetupProfilesPage';
import { MafertAppModuleDetailRoute } from './pages/MafertAppModuleDetailRoute';
import { RolePermissionCleanupPlansPage } from './pages/RolePermissionCleanupPlansPage';
import { SubscriptionChangeRequestsPage } from './pages/SubscriptionChangeRequestsPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
        <Route path="/register" element={<PublicRegisterPage />} />
        <Route path="/register/status/:publicId" element={<PublicRegisterLaunchStatusPage />} />
        <Route path="/accept-invitation/:token" element={<AcceptInvitationPage />} />

        <Route element={<ProtectedRoute />}>
          <Route path="/403" element={<ForbiddenPage />} />
        </Route>

        <Route element={<ProtectedRoute internalOnly />}>
          <Route element={<SystemLayout />}>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/customers" element={<CustomersPage />} />
            <Route path="/customers/:id" element={<CustomerDetailPage />} />
            <Route path="/tenants" element={<TenantsPage />} />
            <Route path="/tenants/:id" element={<TenantDetailPage />} />
            <Route path="/onboarding/trial" element={<TrialOnboardingPage />} />
            <Route path="/onboarding-intents" element={<OnboardingIntentsPage />} />
            <Route path="/onboarding-intents/:id" element={<OnboardingIntentDetailPage />} />
            <Route path="/provisioning/readiness" element={<ProvisioningReadinessPage />} />
            <Route path="/support" element={<SupportInboxPage />} />
            <Route path="/support/notification-settings" element={<SupportNotificationSettingsPage />} />
            <Route path="/support/:id" element={<SupportTicketDetailPage />} />
            <Route path="/plans" element={<PlansPage />} />
            <Route path="/billing" element={<BillingDashboardPage />} />
            <Route path="/billing/invoices" element={<BillingInvoicesPage />} />
            <Route path="/billing/module-prices" element={<BillingModulePricesPage />} />
            <Route path="/billing/pricing-preview" element={<BillingPricingPreviewPage />} />
            <Route path="/billing/sms-usage" element={<BillingSmsUsagePage />} />
            <Route path="/billing/invoices/:id" element={<BillingInvoiceDetailPage />} />
            <Route path="/billing/subscription-changes" element={<SubscriptionChangeRequestsPage />} />
            <Route path="/billing/permission-cleanup" element={<RolePermissionCleanupPlansPage />} />
            <Route path="/plans/:id/features" element={<PlanFeaturesPage />} />
            <Route path="/system-modules/mafertapp" element={<MafertAppModulesPage />} />
            <Route path="/system-modules/mafertapp/:id" element={<MafertAppModuleDetailRoute />} />
            <Route element={<ProtectedRoute superadminOrDeveloperOnly />}>
              <Route path="/features/modules" element={<FeatureModulesPage />} />
              <Route path="/features" element={<FeaturesPage />} />
              <Route path="/entitlements/evaluations" element={<EntitlementEvaluationsPage />} />
              <Route path="/notification-templates" element={<NotificationTemplatesPage />} />
              <Route path="/data-lifecycle/recycle-bin" element={<RecycleBinPage />} />
              <Route path="/data-lifecycle/events" element={<DataLifecycleEventsPage />} />
              <Route path="/data-lifecycle/purge-jobs" element={<DataPurgeJobsPage />} />
              <Route path="/data-lifecycle/retention-policies" element={<RetentionPoliciesPage />} />
            </Route>
            <Route path="/tenant-access" element={<TenantAccessDashboardPage />} />
            <Route path="/tenant-access/checks" element={<TenantAccessChecksPage />} />
            <Route path="/tenant-access/events" element={<TenantAccessEventsPage />} />
            <Route path="/setup-wizard" element={<SetupWizardDashboardPage />} />
            <Route path="/setup-wizard/sessions" element={<SetupWizardSessionsPage />} />
        <Route path="/setup-wizard/events" element={<SetupWizardEventsPage />} />
        <Route path="/setup/module-profiles" element={<ModuleSetupProfilesPage />} />
        <Route path="/tenant-provisioning" element={<TenantProvisioningDashboardPage />} />
            <Route path="/tenant-provisioning/runs" element={<TenantProvisioningRunsPage />} />
            <Route path="/tenant-provisioning/events" element={<TenantProvisioningEventsPage />} />
            <Route path="/tenant-provisioning/health-checks" element={<TenantProvisioningHealthChecksPage />} />
            <Route path="/tenant-schema" element={<TenantSchemaDashboardPage />} />
            <Route path="/tenant-schema/versions" element={<TenantSchemaVersionsPage />} />
            <Route path="/tenant-schema/audit" element={<TenantSchemaAuditPage />} />
            <Route path="/tenant-schema/plans" element={<TenantSchemaPlansPage />} />
            <Route path="/tenant-schema/events" element={<TenantSchemaEventsPage />} />
            <Route path="/subscriptions" element={<SubscriptionsPage />} />
            <Route path="/payments" element={<PaymentsPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/account/security" element={<AccountSecurityPage />} />
            <Route path="/notifications" element={<NotificationsPage />} />
            <Route path="/notification-preferences" element={<NotificationPreferencesPage />} />
            <Route path="/external-providers" element={<ExternalProvidersPage />} />
            <Route path="/external-provider-health" element={<ExternalProviderHealthPage />} />
            <Route path="/stripe" element={<StripeDashboardPage />} />
            <Route path="/stripe/webhooks" element={<StripeWebhookEventsPage />} />
            <Route path="/stripe/sync-logs" element={<StripeSyncLogsPage />} />
          </Route>
        </Route>

        <Route element={<ProtectedRoute portalAccess />}>
          <Route element={<CustomerPortalLayout />}>
            <Route path="/portal" element={<CustomerPortalDashboardPage />} />
            <Route path="/portal/customers" element={<CustomerPortalCustomersPage />} />
            <Route path="/portal/customers/:id" element={<CustomerPortalCustomerDetailPage />} />
            <Route path="/portal/tenants" element={<CustomerPortalTenantsPage />} />
            <Route path="/portal/support" element={<CustomerPortalSupportPage />} />
            <Route path="/portal/support/:id" element={<CustomerPortalSupportTicketPage />} />
            <Route path="/portal/billing" element={<CustomerPortalBillingPage />} />
            <Route path="/portal/entitlements" element={<CustomerPortalEntitlementsPage />} />
            <Route path="/portal/profile" element={<CustomerPortalProfilePage />} />
            <Route path="/portal/account/security" element={<CustomerPortalAccountSecurityPage />} />
            <Route path="/portal/notifications" element={<NotificationsPage />} />
            <Route path="/portal/notification-preferences" element={<NotificationPreferencesPage />} />
          </Route>
        </Route>

        <Route path="*" element={<CatchAllRedirect />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
